import { Coordinates } from "./zone.class";
import {
  Object3D,
  TextureLoader,
  SpriteMaterial,
  Sprite as SpriteThree,
  Vector3,
  MeshBasicMaterial,
} from "three";

interface SpriteBaseStyle {
  url?: string;
  opacity?: number;
  scale?: number;
}

interface SpriteStyle extends SpriteBaseStyle {
  active?: SpriteBaseStyle;
}

interface SpriteParams {
  key: string;
  coords: Coordinates;
  data: object;
  style: SpriteStyle;
}

class Sprite {
  static textureLoader: TextureLoader;
  public readonly type = "Sprite";
  key: string;
  coords: Coordinates;
  data: object;
  style: SpriteStyle;
  object: SpriteThree;
  public baryvector: Vector3;
  isActive: Boolean = false;
  initialized: Boolean = false;
  private onChange: () => void;

  constructor(params: SpriteParams, onChange: () => void) {
    this.data = params.data;
    this.key = params.key;
    this.coords = params.coords;
    this.style = params.style;
    this.isActive = false;
    this.onChange = onChange;
  }

  init3d() {
    const material = new SpriteMaterial();
    const sprite = new SpriteThree(material);
    const [x, y, z] = this.coords;
    sprite.position.set(x, y, z);
    this.baryvector = sprite.position;
    sprite.userData = { type: "sprite", zone: this };
    this.object = sprite;
    this.setStyle();
  }
  setVisible(val: boolean): void {
    this.object.visible = val;
  }
  get3d(): Object3D {
    if (!this.initialized) {
      this.init3d();
    }
    return this.object;
  }
  setStyle(style?: SpriteBaseStyle): void {
    if (!style) {
      style = this.style;
      style.scale = style.scale || 100;
    }
    const material = this.object.material;
    if (style.opacity) {
      material.opacity = style.opacity;
    }
    if (style.url) {
      material.map = Sprite.textureLoader.load(style.url);
    }
    if (style.scale) {
      this.object.scale.set(style.scale, style.scale, style.scale);
    }
    material.needsUpdate = true;
    this.onChange && this.onChange();
  }

  setActive(val: boolean) {
    if (this.isActive === val || !this.style.active) return;
    this.isActive = val;
    const style = this.isActive ? this.style.active : this.style;
    this.setStyle(style);
  }
}

export { Sprite, SpriteParams, SpriteStyle };
